// src/components/ErrorSnackbar.js
import React from 'react';
import { Snackbar, Alert, IconButton } from '@mui/material';
import { useAppContext } from '../contexts/AppContext';
import { Close } from '@mui/icons-material';

const AppSnackbar = () => {
  const { appState, updateAppState } = useAppContext();
  const message = appState.error ?? appState.success ?? '';
  const isOpen = typeof message === 'string' ? message.trim().length > 0 : Boolean(message);

  const handleClose = () => {
    updateAppState({ error: null, success: null });
  };

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={5000}
      onClose={handleClose}
    >
      <Alert
        severity={appState.error ? 'error' : 'success'}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <Close fontSize="inherit" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AppSnackbar;
